import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { TooltipProvider } from "@/components/ui/tooltip";
import { Toaster } from "@/components/ui/sonner";
import { PaymentPage } from "./pages/PaymentPage";
import { PreviewPage } from "./pages/PreviewPage";
import { BillApprovalPage } from "./pages/BillApprovalPage";
import { BillPdfPreviewPage } from "./pages/BillPdfPreviewPage";
import { BillPaymentPage } from "./pages/BillPaymentPage";
import { DemoBankPage } from "./pages/DemoBankPage";
import { NotFoundPage } from "./pages/NotFoundPage";
import "./index.css";

function ExternalRedirect({ to }: { to: string }) {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
}

function AppRoutes() {
  return (
    <Routes>
      <Route path="/i/preview" element={<PreviewPage />} />
      <Route path="/i/:token" element={<PaymentPage />} />
      <Route path="/b/:token/pdf" element={<BillPdfPreviewPage />} />
      <Route path="/b/:token" element={<BillApprovalPage />} />
      <Route path="/p/:token" element={<BillPaymentPage />} />
      <Route path="/demo-bank" element={<DemoBankPage />} />
      <Route path="/" element={<ExternalRedirect to="https://dolfinai.co" />} />
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export function App() {
  return (
    <TooltipProvider>
      <BrowserRouter>
        <AppRoutes />
        <Toaster />
      </BrowserRouter>
    </TooltipProvider>
  );
}

export default App;
